import toast from "react-hot-toast";

/* ---------- SUCCESS ---------- */
export const showSuccess = (message) => {
  toast.success(message, {
    duration: 3000,
  });
};

/* ---------- ERROR ---------- */
export const showError = (message) => {
  toast.error(message, {
    duration: 4000,
  });
};

/* ---------- LOADING ---------- */
export const showLoading = (message = "Please wait...") => {
  return toast.loading(message);
};

/* ---------- DISMISS ---------- */
export const dismissToast = (toastId) => {
  toast.dismiss(toastId);
};

/* ---------- PROMISE ---------- */
export const showPromiseToast = (promise, messages) => {
  return toast.promise(promise, {
    loading: messages?.loading || "Processing...",
    success: messages?.success || "Success!",
    error: (err) =>
      err?.response?.data?.message ||
      messages?.error ||
      "Something went wrong!",
  });
};
